import { PATHS } from '~/pages/router/paths'

interface Params {
  [key: string]: string
}

export default function makePathname(path: string, params: Params) {
  const { customerIdentifier, productId, accountNumber } = params
  switch (path) {
    case PATHS.CUSTOMER:
      return `/${PATHS.CUSTOMER}/${customerIdentifier}`
    case PATHS.PRODUCT:
      return `/${PATHS.CUSTOMER}/${customerIdentifier}/${PATHS.PRODUCT}/${productId}`
    case PATHS.OFFERS_CONFIGURATOR:
      return `/${PATHS.CUSTOMER}/${customerIdentifier}/${PATHS.OFFERS_CONFIGURATOR}/${accountNumber}`
    case PATHS.RECHARGES:
      return `/${PATHS.CUSTOMER}/${customerIdentifier}/${PATHS.PRODUCT}/${productId}/recharges`
    default:
      return '/'
  }
}
